import { render, staticRenderFns } from "./FooterHome2.vue?vue&type=template&id=5ed5c5b7&scoped=true"
import script from "./FooterHome2.vue?vue&type=script&lang=js"
export * from "./FooterHome2.vue?vue&type=script&lang=js"
import style0 from "./FooterHome2.vue?vue&type=style&index=0&id=5ed5c5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5c5b7",
  null
  
)

export default component.exports